export const faqs = [
  {
    q: "「热瓜前线」主要提供什么内容？",
    a: "我们聚合全网正在讨论的热点话题，用观察和梳理的方式帮你快速了解一件事的来龙去脉，包括网络热议、娱乐风向、社会百态、科技新鲜事等方向，尽量做到有信息量、有分寸。",
  },
  {
    q: "网站上的热度数据是怎么来的？",
    a: "热度是编辑根据话题的讨论量、转发趋势和持续时间综合给出的参考值，用来帮助你判断哪些话题当前更值得关注，并不代表对话题真实性的判断。",
  },
  {
    q: "我发现了一条值得关注的线索，可以投稿吗？",
    a: "可以。你可以通过页面底部或订阅区的线索表单提交话题线索，我们会先做基础核实，再决定是否整理成观察文章。请尽量附上可查证的公开信息来源。",
  },
  {
    q: "为什么有些话题看起来「刚热就凉」？",
    a: "话题有生命周期。短视频和信息流的传播节奏加快后，很多话题的集中讨论期只有几天。我们会在话题降温后补一篇复盘，帮你看清它为什么没持续下去。",
  },
  {
    q: "网站会对话题中的人物下结论吗？",
    a: "不会。我们只讨论可公开查证的事实和现象本身，不对个人做定性判断，也不传播未经证实的信息。看到让你不适的内容，欢迎通过联系方式反馈。",
  },
  {
    q: "订阅后多久更新一次？",
    a: "通常工作日每日更新，遇到重大话题会加更。订阅只会发送我们精选后的内容摘要，不会频繁打扰。",
  },
];